import { NgModule } from '@angular/core';
//declaration
import { SlideToggleDouble } from './elements';
import { MaterialModule } from '../../material';
import { UIToolsModule } from '../../uitools';
import { Card } from './elements/card';
import { CommonModule } from '@angular/common';


const declarationsAndExports: Array<any> = [
	// SlideToggleDouble
	Card
]
@NgModule({
	imports: [CommonModule, MaterialModule, UIToolsModule],
	declarations: [declarationsAndExports],
	exports: [declarationsAndExports, CommonModule, MaterialModule, UIToolsModule],
	providers: []
})
export class UIElementModule { }
